var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vp-weights-popup",class:{
        'vp-weights-popup--top': _vm.bottom,
        'vp-weights-popup--main-column': _vm.mainColumn,
    },attrs:{"id":_vm.id ? `vp-weight-popup-${_vm.id}` : ''}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }